import React from 'react';
import { Loader } from 'freemium-ui';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Icon from '../../../shared/components/Icon';
import { Center } from '../../../shared/styles';
import request from '../../../utils/request';
import i18n from '../../../i18n';

const useQueryParams = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

const EmailVerify = () => {
  const query = useQueryParams();
  const [isVerified, setIsVerified] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const verifyEmail = async (token: string) => {
    await request(`/surveyserv/email-verify/verify/${token}`, {}, 'PUT').catch(
      (e: any) => {
        if (e.response.status === 200) setIsVerified(true);
        else setErrorMsg(e.response.data);
      },
    );
    setIsVerified(true);
  };

  React.useEffect(() => {
    const token = query.get('token');
    if (token) verifyEmail(token);
  }, []);

  if (isVerified || errorMsg)
    return (
      <StyledStatus>
        <img src="/freshsurvey.svg" alt="FreshSurvey" className="logo" />
        <div className="message-container">
          <Icon glyph="email-verified" height={90} width={90} />
          {!errorMsg ? (
            <h3> {i18n.t('forms.err_msg.email_verified')}</h3>
          ) : null}
          <div className="message">
            {errorMsg || `${i18n.t('forms.err_msg.email_confirmation')}`}
          </div>
        </div>
      </StyledStatus>
    );

  return (
    <Center>
      <Loader />
    </Center>
  );
};

export default EmailVerify;

const StyledStatus = styled.div`
  margin: 0 auto;
  margin-top: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .logo {
    margin-bottom: 50px;
    width: 225px;
  }

  @media (max-width: 767px) {
    .logo {
      width: 55%;
      margin-bottom: 30px;
    }
    .message-container {
      width: 90% !important;
      padding: 26px 32px !important;
    }

    h3 {
      font-size: 24px !important;
    }

    .message {
      margin-top: 10px !important;
    }
  }

  .message-container {
    color: #12344d !important;
    border: 1px solid #ebeff3;
    box-shadow: 0px 2px 5px rgba(18, 52, 77, 0.1);
    border-radius: 4px;
    padding: 50px 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 700px;
    max-height: 335px;
    margin: 0 auto;
    box-sizing: border-box;
    background-color: #f6f6f6;
  }

  h3 {
    font-weight: 700;
    font-size: 28px;
    line-height: 35px;
    text-align: center;
    color: #12344d;
    margin-top: 10px;
  }

  .message {
    margin-top: 20px;
    font-weight: 500;
    font-size: 18px;
    line-height: 35px;
    text-align: center;
    color: #12344d;
  }
`;
